import { render, staticRenderFns } from "./ShutterType.vue?vue&type=template&id=6bfdf37f&scoped=true"
import script from "./ShutterType.vue?vue&type=script&lang=ts"
export * from "./ShutterType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfdf37f",
  null
  
)

export default component.exports